import { View, Text as PDFText } from '@react-pdf/renderer'

import { getCurrencyLabel } from '../../../../../helpers/currencies'
import { RoomStay } from '../../../../../types/bookingDetails'
import { Currency } from '../../../../../types/currency'
import { PriceRow, PriceRowKind, priceRows } from '../../../statement'
import { addCommaToPrice, mirrorParens } from '../../config/functions'
import styles from './styles/index.styles'

interface PriceDetailsProps {
  data: RoomStay
  currency: Currency
}

const LABEL: Record<PriceRowKind, string> = {
  listPrice: 'مبلغ قبل از تخفیف',
  rateDiscount: 'تخفیف نرخ',
  additionalDiscount: 'تخفیف اپراتور',
  promotion: 'تخفیف تشویقی (اعمال‌شده)',
  changePenalty: 'جریمه تغییر',
  cancelPenalty: 'جریمه لغو',
  total: 'مبلغ کل قابل پرداخت'
}

const SIGN: Record<PriceRow['sign'], string> = { '': '', '-': '−', '+': '+' }

const toneStyle = (row: PriceRow) => {
  if (row.isTotal) return styles.totalAmount
  if (row.tone === 'discount') return styles.discountAmount
  if (row.tone === 'penalty') return styles.penaltyAmount
  return styles.lineAmount
}

// A statement: label on the right; on the left a fixed-width amount, right-aligned, then
// a fixed-width sign cell, so every sign sits in one column and the amounts line up.
export const PriceDetails = ({ data, currency }: PriceDetailsProps) => {
  const rows = priceRows(data)
  const currencyLabel = getCurrencyLabel(currency || '')

  return (
    <View style={styles.mainDiv}>
      <View style={styles.statement}>
        {rows.map((row) => (
          <View
            key={row.kind}
            style={row.isTotal ? [styles.line, styles.totalLine] : styles.line}>
            <PDFText style={row.isTotal ? styles.totalLabel : styles.lineLabel}>
              {mirrorParens(LABEL[row.kind])}
            </PDFText>
            <View style={styles.amountCell}>
              <PDFText style={[styles.amount, toneStyle(row)]}>
                {`${addCommaToPrice(row.amount)} ${currencyLabel}`}
              </PDFText>
              <PDFText style={[styles.sign, toneStyle(row)]}>
                {SIGN[row.sign]}
              </PDFText>
            </View>
          </View>
        ))}
      </View>
      <View style={styles.priceTitleContainer}>
        <PDFText style={styles.subtitle}>جزییات قیمت</PDFText>
      </View>
    </View>
  )
}
